import { session_third } from "@tencent/midas-util"

export class ThirdAccount {
  init(opt) {
    return new Promise((resolve, reject) => {
      if (opt.openid && opt.openkey) {
        let loginState = new session_third({
          openid: opt.openid,
          openkey: opt.openkey
        })
        resolve({ loginState: loginState })
      } else {
        reject("无登录态")
      }
    })
  }
}
